<template>
  <router-view />
</template>

<script>
export default {
  name: 'IslandVacationIndex'
}
</script>
